import Occasion from '@support/Occasion';
import BaseObject from '../Models/BaseObject';

export default class UserStats extends BaseObject {
  contacts: number;
  emails: number;
  moments: number;
  earliestMoment: Occasion;

  constructor(props: any = {}) {
    super(props);

    this.contacts = props.contacts || 0;
    this.emails = props.emails || 0;
    this.moments = props.moments || 0;
    this.earliestMoment = new Occasion(props.first_moment_date);
  }
}
